module.exports.DebitNote = (generalData,wageData,getCompanyName)=>{
    console.log(generalData)
    let sumWeight = 0
    let licenseArray = ''
    let companyName = getCompanyName(generalData['description']['companyID'])
    generalData['description']['description'].map((data)=>{
        sumWeight += parseFloat(data['quantity'])
        licenseArray += `${data['licenseID'].slice(data['licenseID'].length - 5 ,data['licenseID'].length)},`
    })
    sumWeight = sumWeight.toFixed(6)
    licenseArray = licenseArray.slice(0,licenseArray.length-1)
    let amount = ((parseFloat(sumWeight)*100000)*2.5/100000).toFixed(2)
    let amountThai = ThaiNumberToText(amount)
    let jsPDF = require('jspdf')
    let font = require('./THSarabun-normal')
    let fontbold = require('./THSarabun-bold')
    let doc = new jsPDF('p', 'mm', [946.98, 595.40])
    doc.addFileToVFS('THSarabun-normal.ttf', font.addFont());
    doc.addFont('THSarabun-normal.ttf', 'THSarabun', 'normal');
    doc.addFileToVFS('THSarabun-bold.ttf', fontbold.addFont());
    doc.addFont('THSarabun-bold.ttf', 'THSarabun', 'bold');
    doc.setFont('THSarabun')

    doc.setFontType('bold')
    doc.setFontSize(22)
    doc.text(`สำนักงานคณะกรรมการตรวจข้าว`, 70, 10) ;     doc.roundedRect(150,5,50,20,2,2);
    doc.text(`สภาหอการค้าแห่งประเทศไทย`, 73, 18) ;        doc.text(`ต้นฉบับใบแจ้งหนี้`, 156, 13);     doc.text(`DEBIT NOTE`, 160, 21);
    doc.setFontSize(14)
    doc.text(`92/43 อาคารสาธรธานี 2 ชั้น 16 ถนนสาทรเหนือ แขวงสีลม`, 60, 26)
    doc.text(`เขตบางรัก กรุงเทพฯ 10500 โทร 0-22333416-7 โทรสาร 0-22333418`, 50, 34); doc.text(`สาขาที่ 00001`, 165, 34)
    doc.setFontType('normal') ; doc.roundedRect(150,37,50,7,2,2);    
    doc.text(`เลขประจำตัวผู้เสียภาษีอากร 0108511000011`, 73, 42);     doc.text(`เลขที่ `, 160, 42); doc.text(`143640`,172,42);

    doc.setFontType('bold')
    doc.setFontSize(14)
    doc.text(`รหัสลูกค้า`,20,53);     doc.text(`คำสั่งจ่ายงาน`,65,53);     doc.text(`วันที่`,115,53);      doc.text(`อัตราภาษีร้อยละ`,150,53) ; doc.text(`7`,180,53)
    doc.text(`CODE NO.`,20,59);        doc.text(`JOB NO.`,65,59);        doc.text(`DATE`,115,59);     doc.text(`PERCENTAGE RATE`,150,59)

    doc.text(`ชื่อผู้ชำระ`,20,70); doc.text(`${companyName}`,40,70)
    doc.text(`NAME OF PAYEE`,20,77)
    doc.text(`ที่อยู่`,20,84); doc.text(`99 หมู่ที่ 1 ต.คลองเจ็ด อ.คลองหลวง จ.ปทุมธานี`,40,84)
    doc.text(`ADDRESS`,20,91)

    doc.text(`รายการ`,80,98);                                                 doc.text(`จำนวนเงิน`,175,98)
    doc.text(`DESCRIPTION`,75,105);                                            doc.text(`AMOUNT`,175,105)

    doc.text(`ค่าบำรุงการตรวจข้าว`,20,115);doc.text(`${sumWeight}`,55,115) ; doc.text(`ม./ตัน ๆ ละ`,80,115);doc.text(`2.5`,110,115); doc.text(`บาท / อัตราขั้นต่ำ`,130,115); doc.text(`${amount}`,180,115);
    doc.text(`ตามหนังสือรับรองคุณภาพและน้ำหนักข้าวเลขที่`,20,123);     doc.text(`${licenseArray}`,95,123); 
    doc.text(`ค่าล่วงเวลา วันที่`,20,131); doc.text(`ตั้งแต่`,80,131);  doc.text(`น. ถึง `,110,131); doc.text(`น.`,140,131); 
                                   doc.text(`ตั้งแต่`,80,139);  doc.text(`น. ถึง `,110,139); doc.text(`น.`,140,139);
                                                                        doc.text(`รวมราคาทั้งสิ้น`,140,240);
                                                                        doc.text(`AMOUNT`,145,248);
                                                                        doc.text(`จำนวนภาษีมูลค่าเพิ่ม`,135,256);
                                                                        doc.text(`VAT`,148,264);
    doc.text(`ตัวอักษร`,20,272);      doc.text(`${amountThai}`,40,272);   doc.text(`รวมราคาทั้งสิ้น`,140,272);
    doc.text(`ALPHABET`,20,280);                                        doc.text(`TOTAL`,147,280);
                                                                        doc.text(`ส่วนบัญชี`,148,290);
                                                                        doc.text(`ACCOUNT DEPARTMENT`,137,295);
                                                                        doc.text(`ผู้ได้รับมอบอำนาจ/AUTHORIZED SIGNATURE`,125,320);
    doc.rect(15,45,185,237)
    doc.rect(15,45,45,17)
    doc.rect(15,45,95,17)
    doc.rect(15,45,132,17)
    doc.rect(15,45,185,17)
    doc.rect(15,45,185,49)
    doc.rect(15,45,185,63)
    doc.rect(15,45,185,190)
    doc.rect(15,45,185,222)
    doc.rect(170,94,30,188)
    doc.rect(130,235,70,16)
    doc.rect(130,235,70,32)
    doc.rect(130,235,70,47)
    doc.rect(115,285,85,38)
    doc.rect(115,285,85,12)

    doc.output('dataurlnewwindow');

    // doc.save('test.pdf')
}


function ThaiNumberToText(Number)
{
	Number = Number.replace (/๐/gi,'0');  
	Number = Number.replace (/๑/gi,'1');  
	Number = Number.replace (/๒/gi,'2');
	Number = Number.replace (/๓/gi,'3');
	Number = Number.replace (/๔/gi,'4');
	Number = Number.replace (/๕/gi,'5');
	Number = Number.replace (/๖/gi,'6');
	Number = Number.replace (/๗/gi,'7');
	Number = Number.replace (/๘/gi,'8');
	Number = Number.replace (/๙/gi,'9');
	return 	ArabicNumberToText(Number);
}

function ArabicNumberToText(Number)
{
	var Number = CheckNumber(Number);
	var NumberArray = new Array ("ศูนย์", "หนึ่ง", "สอง", "สาม", "สี่", "ห้า", "หก", "เจ็ด", "แปด", "เก้า", "สิบ");
	var DigitArray = new Array ("", "สิบ", "ร้อย", "พัน", "หมื่น", "แสน", "ล้าน");
	var BahtText = "";
	if (isNaN(Number))
	{
		return "ข้อมูลนำเข้าไม่ถูกต้อง";
	} else
	{
		if ((Number - 0) > 9999999.9999)
		{
			return "ข้อมูลนำเข้าเกินขอบเขตที่ตั้งไว้";
		} else
		{
			Number = Number.split (".");
			if (Number[1].length > 0)
			{
				Number[1] = Number[1].substring(0, 2);
			}
			var NumberLen = Number[0].length - 0;
			for(var i = 0; i < NumberLen; i++)
			{
				var tmp = Number[0].substring(i, i + 1) - 0;
				if (tmp != 0)
				{
					if ((i == (NumberLen - 1)) && (tmp == 1))
					{
						BahtText += "เอ็ด";
					} else
					if ((i == (NumberLen - 2)) && (tmp == 2))
					{
						BahtText += "ยี่";
					} else
					if ((i == (NumberLen - 2)) && (tmp == 1))
					{
						BahtText += "";
					} else
					{
						BahtText += NumberArray[tmp];
					}
					BahtText += DigitArray[NumberLen - i - 1];
				}
			}
			BahtText += "บาท";
			if ((Number[1] == "0") || (Number[1] == "00"))
			{
				BahtText += "ถ้วน";
			} else
			{
                let DecimalLen = Number[1].length - 0;
				for (var i = 0; i < DecimalLen; i++)
				{
					var tmp = Number[1].substring(i, i + 1) - 0;
					if (tmp != 0)
					{
						if ((i == (DecimalLen - 1)) && (tmp == 1))
						{
							BahtText += "เอ็ด";
						} else
						if ((i == (DecimalLen - 2)) && (tmp == 2))
						{
							BahtText += "ยี่";
						} else
						if ((i == (DecimalLen - 2)) && (tmp == 1))
						{
							BahtText += "";
						} else
						{
							BahtText += NumberArray[tmp];
						}
						BahtText += DigitArray[DecimalLen - i - 1];
					}
				}
				BahtText += "สตางค์";
			}
			return BahtText;
		}
	}
}

function CheckNumber(Number){
	var decimal = false;
	Number = Number.toString();						
	Number = Number.replace (/ |,|บาท|฿/gi,'');  		
	for (var i = 0; i < Number.length; i++)
	{
		if(Number[i] =='.'){
			decimal = true;
		}
	}
	if(decimal == false){
		Number = Number+'.00';
	}
	return Number
}
